import Alpine from "alpinejs";
Alpine.data("imageGallery", () => ({
    init() {
    }
}));